import { render, staticRenderFns } from "./PlanPilarList.vue?vue&type=template&id=347149b0&lang=pug"
import script from "./PlanPilarList.vue?vue&type=script&lang=js"
export * from "./PlanPilarList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347149b0')) {
      api.createRecord('347149b0', component.options)
    } else {
      api.reload('347149b0', component.options)
    }
    module.hot.accept("./PlanPilarList.vue?vue&type=template&id=347149b0&lang=pug", function () {
      api.rerender('347149b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/data_strategy/components/PlanPilarList.vue"
export default component.exports